import { Reveal, SectionHead } from "./Reveal";
import { TESTIMONIALS } from "../data/content";

export const Testimonials = () => (
  <section className="bg-surface border-y border-line py-24 md:py-32" data-testid="testimonials-section">
    <div className="container-x">
      <SectionHead
        kicker="Kundenstimmen"
        testId="testimonials-title"
        title={<>Woran man uns <span className="font-fraktur text-golddark">misst.</span></>}
        text="Vertrauen entsteht durch geleistete Arbeit – und durch das, was Kunden nach der Abnahme sagen."
      />
      <div className="grid md:grid-cols-3 gap-x-10 gap-y-12">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.source} delay={i * 0.08}>
            <figure className="border-l border-line pl-8 h-full flex flex-col" data-testid={`testimonial-${i}`}>
              <blockquote className="font-display text-2xl md:text-[1.7rem] font-medium leading-snug text-ink text-balance">
                {t.quote}
              </blockquote>
              <figcaption className="font-mono text-[10px] uppercase tracking-[0.18em] font-bold text-muted mt-7">
                {t.source}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
